import React from 'react';
import logo from '../../assets/logo.png';
import * as ReactBootStrap from 'react-bootstrap';
import { Link, NavLink, Redirect } from 'react-router-dom';
import "./Header.css";
import { faPhoneAlt,faEnvelope,} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Config from '../../config/index'


 
function Header(props) {

  return( 
<div id="main-header">
  <div className="row header-top col-lg-12 p-0 m-0 text-white">
  <div className="col-sm-5 col-xs-12 align-self-center " style={{marginLeft:"10vw"}}>
          <p className="mb-0  pb-md-0">            
          <FontAwesomeIcon className="mr-2" icon={faPhoneAlt}/>
           <a className="" href="tel:[65] 6749 1822">[65] 6749 1822</a>
           <FontAwesomeIcon className="ml-3 mr-2" icon={faEnvelope}/>
               <a className="" href="mailto:airhub@siaa.org">airhub@siaa.org</a>
          </p>
        </div>
        <div className="col-sm-5 col-xs-12 d-flex align-items-center" >
          <div className="ml-md-auto mx-auto mx-md-0 mt-3 mb-1 my-md-0 hide">
            <a className="icon-sm icon-default icon-border hover-bg-primary rounded-circle ml-2" 
          href="#facebook">
              <i className="fa fa-facebook mr-3" aria-hidden="true"></i>
            </a>
            <a className="icon-sm icon-default icon-border hover-bg-primary rounded-circle ml-2" href="#twitter">
              <i className="fa fa-twitter mr-3" aria-hidden="true"></i>
            </a>
           <a className="icon-sm icon-default icon-border hover-bg-primary rounded-circle ml-2" href="#linkedin">
              <i className="fa fa-linkedin mr-3" aria-hidden="true"></i>
            </a>
          </div>
        </div>
  </div>
  
<ReactBootStrap.Navbar collapseOnSelect expand="lg" bg="white" className="col-lg-12 px-0 py-1">
  <ReactBootStrap.Navbar.Brand href="/" style={{marginLeft:"10vw"}}>
      <img  src={logo} style={{height:50}} alt="AIRHUB Logo">
      </img>
  </ReactBootStrap.Navbar.Brand>
  <ReactBootStrap.Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <ReactBootStrap.Navbar.Collapse id="responsive-navbar-nav">
    <ReactBootStrap.Nav className="ml-auto pl-2">
     <ReactBootStrap.Nav.Link as={NavLink} to="/"  style={{color:"#233F87"}}>Home</ReactBootStrap.Nav.Link> 
     <ReactBootStrap.Nav.Link as={NavLink} to="/aboutus">About Us</ReactBootStrap.Nav.Link>      
     <ReactBootStrap.Nav.Link as={NavLink}  to="/signout"  >{props.link3}</ReactBootStrap.Nav.Link>
   <ReactBootStrap.Nav.Link as={NavLink} className="pt-0" to="/signup"><span className="btn-md btn btn-primary" style={{fontWeight:"500",fontSize:"20px",lineHeight:"20px"}}>Sign Up</span></ReactBootStrap.Nav.Link>
    </ReactBootStrap.Nav>
  </ReactBootStrap.Navbar.Collapse>
</ReactBootStrap.Navbar>
  
</div>
 
  );
}
 
export default Header;